var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.currentShowBetaCodesInfo,
          expression: "currentShowBetaCodesInfo",
        },
      ],
      staticClass: "alpheios-lookup__form-beta-codes-info",
    },
    [
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.l10n.getMsg("LOOKUP_USE_BETA_CODES_INFO_FIRST")
          ),
        },
      }),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("a => α")]),
      _c("span", [_vm._v("b => β")]),
      _c("span", [_vm._v("c => ξ")]),
      _c("span", [_vm._v("d => δ")]),
      _c("span", [_vm._v("e => ε")]),
      _vm._v(" "),
      _c("span", [_vm._v("f => φ")]),
      _c("span", [_vm._v("g => γ")]),
      _c("span", [_vm._v("h => η")]),
      _c("span", [_vm._v("i => ι")]),
      _c("span", [_vm._v("k => κ")]),
      _vm._v(" "),
      _c("span", [_vm._v("l => λ")]),
      _c("span", [_vm._v("m => μ")]),
      _c("span", [_vm._v("n => ν")]),
      _c("span", [_vm._v("o => ο")]),
      _c("span", [_vm._v("p => π")]),
      _vm._v(" "),
      _c("span", [_vm._v("q => θ")]),
      _c("span", [_vm._v("r => ρ")]),
      _c("span", [_vm._v("s => σ, ς")]),
      _c("span", [_vm._v("t => τ")]),
      _c("span", [_vm._v("u => υ")]),
      _vm._v(" "),
      _c("span", [_vm._v("v => ϝ")]),
      _c("span", [_vm._v("w => ω")]),
      _c("span", [_vm._v("x => χ")]),
      _c("span", [_vm._v("y => ψ")]),
      _c("span", [_vm._v("z => ζ")]),
      _vm._v(" "),
      _c("span", [_vm._v("/a => ά")]),
      _c("span", [_vm._v("\\a => ὰ")]),
      _c("span", [_vm._v("=a => ᾶ")]),
      _c("span", [_vm._v(")a => ἀ")]),
      _c("span", [_vm._v("(a => ἁ")]),
      _vm._v(" "),
      _c("span", [_vm._v("|a => ᾳ")]),
      _c("span", [_vm._v("_a => ᾱ")]),
      _c("span", [_vm._v("^a => ᾰ")]),
      _c("span", [_vm._v("+i => ϊ")]),
      _c("span", [_vm._v("(/|a => ᾅ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }